module.exports = __webpack_public_path__ + "static/media/8.d66af8e6.jpg";